// extracted by mini-css-extract-plugin
module.exports = {"container":"checkbox_container__SdYya","hover":"checkbox_hover__Fe85g","disabled":"checkbox_disabled__c_sPe"};